import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { NotificationsService } from 'angular2-notifications';
import { GenericIdName } from '../../../shared/models/common-search-filters.model';
import { CommonFiltersService } from '../../../shared/services/common-search-filters.service';
import { ActionRecommendationService } from '../action-recommendations.service';
import { ActionRecommendationRuleDetailsViewModel, ActionRecommendationsViewModel } from '../action-recommendations.model';
import { MatDialogRef, MatDialog, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatTableDataSource } from '@angular/material/table';

@Component({
  selector: 'app-action-recommendation-rule-detail',
  templateUrl: './action-recommendation-rule-detail.component.html',
  styleUrls: ['./action-recommendation-rule-detail.component.scss']
})
export class ActionRecommendationRuleDetailComponent implements OnInit {
  // Drop-down lists
  customers: GenericIdName[] = [];
  jobsites: GenericIdName[] = [];
  models: GenericIdName[] = [];
  comparttypes: GenericIdName[] = [];
  compartsides: GenericIdName[] = [];
  Positions: GenericIdName[] = [];
  ActionTypes: GenericIdName[] = [];
  _RuleViewModel: ActionRecommendationsViewModel = new ActionRecommendationsViewModel();
  //Search Filters
  selectedCustomer: number;
  selectedJobsite: number;
  selectedModel: number;


  _RuleName: string;
  _RuleDesc: string;
  _Components: string;

  _RuleId: number;

  _ruleComponentId: number;
  selectedCompartType: number;
  selectedCompartSide: number;
  selectedActionType: number;
  selectedPosition: number;
  selectedNewPosition: number;
  selectedDesc: string;
  selectedExtendedHrs: number;
  selectedLabour: number;
  selectedParts: number;
  selectedMisc: number;
  selectedTotalCost: number;

  inspectionId: number;
  quoteId: number;
  componentId: number;

  _loadRuleDetailForEdit: boolean;

  loadingPossibleRecommendations: boolean;
  savingForm: boolean;
  loading: boolean;

  displayedColumns: string[] = ['EditCol', 'CompType', 'Side', 'Pos', 'ActionType', 'NewPos', 'DetailedDescription', 'ExtendedHrs', 'Labour', 'Parts', 'Misc', 'TotalCost', 'CreatedDate', 'By', 'Delete'];

  dataSource = new MatTableDataSource();
  constructor(private _dialogRef: MatDialogRef<ActionRecommendationRuleDetailComponent>, private _dialog: MatDialog,
    private _CommonFiltersService: CommonFiltersService,
    private _RuleService: ActionRecommendationService,
    @Inject(MAT_DIALOG_DATA) private _data: any,
    private _notify: NotificationsService,
  private _fb: FormBuilder) { }

  ngOnInit() {

    console.log("Data", this._data)
    this.loading = true;
    this.loadingPossibleRecommendations = true;
    this.inspectionId = this._data.inspectionId;

    this.selectedCustomer = 0;
    this.selectedJobsite = 0;
    this.selectedModel = 0;
    this._RuleId = this._data.RuleId;

    this.loadModels();
    if (this._RuleId > 0) {
      this.getRule();
    }
    else {
      this.getDDLDataForInspection();
    }

    //this.quoteId = this._data.quoteId;
    //this.componentId = this._data.componentId;
    this.loadCustomers();
   
    
    this._RuleId = 0;

    this._ruleComponentId = 0;
    this.selectedCompartType = 0;
    this.selectedCompartSide = 0;
    this.selectedPosition = 0;
    this.selectedActionType = 0;
    this.selectedNewPosition = 0;
    this.selectedDesc = '';
    this.selectedExtendedHrs = 0;
    this.selectedLabour = 0;
    this.selectedParts = 0;
    this.selectedMisc = 0;
    this.selectedTotalCost = 0;

  }

  loadCustomers() {
    this.customers = null
    this._CommonFiltersService.getCustomerList().subscribe(r => {
      if (r) {
        this.customers = r;
      }
    });
  }

  loadJobSites() {
    if (this.selectedCustomer == null)
      return;
    this.jobsites = null
    this._CommonFiltersService.getJobsiteList(this.selectedCustomer).subscribe(r => {
      if (r) {
        this.jobsites = r;
      }
    });
  }

  loadModels() {
    this.models = null
    this._CommonFiltersService.getModelList().subscribe(r => {
      if (r) {
        this.models = r;
      }
    });
  }

  loadCompartTypes() {
    if (this.selectedModel == null)
      return;
    this.comparttypes = null;
    this._CommonFiltersService.getCompartTypeList(this.selectedModel).subscribe(r => {
      if (r) {
        this.comparttypes = r;
      }
    });
  }

  loadCompartSides() {
    this.compartsides = null;
    this.compartsides = [
      { Id: 0, Name: "" },
      { Id: 1, Name: "Left" },
      { Id: 2, Name: "Right" }
    ];
  }

  loadPositions() {
    if (this.selectedModel == null)
      return;
    this.Positions = null;
    this._CommonFiltersService.getPositionList(this.selectedModel, this.selectedCompartType).subscribe(r => {
      if (r) {
        this.Positions = r;
      }
    });
  }

  loadActionTypes() {
    if (this.selectedCompartType == null)
      return;
    this.ActionTypes = null;
    this._CommonFiltersService.getActionTypeList(this.selectedCompartType).subscribe(r => {
      if (r) {
        this.ActionTypes = r;
      }
    });
  }

  onChangeCompType() {
    this.loadCompartSides();
    this.loadPositions();
    this.loadActionTypes();
  }

  getRule() {
    console.log("info",this._RuleId, this.selectedCustomer, this.selectedJobsite, this.selectedModel)
    this._RuleService.GetActionRecommendationRules(this._RuleId, this.selectedCustomer, this.selectedJobsite, this.selectedModel).subscribe(rec => {
      this._RuleViewModel = rec[0];
      this._RuleId = this._RuleViewModel.RuleId;
      this.selectedCustomer = this._RuleViewModel.CustomerId;
      this.selectedJobsite = this._RuleViewModel.JobSiteId;
      this.selectedModel = this._RuleViewModel.ModelId;
      this._RuleName = this._RuleViewModel.RuleName;
      this._RuleDesc = this._RuleViewModel.RuleDesc;
      this._Components = this._RuleViewModel.Components;
      this.loadJobSites();
      this.loadModels();
      this.loadCompartTypes();
      this.getRuleComponents();
      this.loadingPossibleRecommendations = false;
    }, err => {
      this._notify.error('Error', 'Unable to load possible recommendations. Please contact TrackTreads support. ');
      console.error(err);
      this.loadingPossibleRecommendations = false;
    });
  }

  setRule() {
    this.savingForm = true;
    const rec = new ActionRecommendationsViewModel();
    rec.RuleId = this._RuleId;
    rec.RuleName = this._RuleName;
    rec.RuleDesc = this._RuleDesc;
    rec.CustomerId = this.selectedCustomer;
    rec.JobSiteId = this.selectedJobsite;
    rec.ModelId = this.selectedModel;

    if(this._RuleName=="" || this._RuleName==null){
      this._notify.error('Error', 'Please enter Rule name.');
    }else{
      this._RuleService.SetActionRecommendationRules(rec).subscribe(r => {
        this._RuleId = r;
        this.loadCompartTypes();
        this.getRuleComponents();
        this.savingForm = false;
        this._notify.success('Added', this._RuleId > 0 ? "Rule update successfully." : "Rule save successfully.");
      }, error => {
        this._notify.error('Error', 'Unable to save action recommendation rule. Please contact TrackTreads support. ');
        console.error(error);
        this.savingForm = false;
      });
    }
    
  }

  addRuleComponent() {
    if (this.selectedCompartType > 0) {
      if (this.selectedNewPosition == 0 && (this.selectedActionType == 5 || this.selectedActionType == 17 || this.selectedActionType == 20 || this.selectedActionType == 10602 || this.selectedActionType == 10702)) {
        this._notify.error('Error', 'Unable to add Component. Please select new position. ');
      }
      else {
        if (this._RuleId > 0) {
          this.savingForm = true;
          const rec = new ActionRecommendationRuleDetailsViewModel();
          rec.RuleId = this._RuleId;
          rec.RuleComponentId = this._ruleComponentId;
          rec.ComponentTypeId = this.selectedCompartType;
          rec.Side = this.selectedCompartSide;
          rec.Position = this.selectedPosition;
          rec.ActionTypeId = this.selectedActionType;
          rec.NewPosition = this.selectedNewPosition;
          rec.Description = this.selectedDesc;
          rec.LifeExtendedHours = this.selectedExtendedHrs;
          rec.LabourCost = this.selectedLabour;
          rec.PartCost = this.selectedParts;
          rec.MiscCost = this.selectedMisc;
          this._RuleService.AddActionRecommendationRuleComponent(rec).subscribe(r => {
            this._ruleComponentId = r;
            this.getRuleComponents();
            this._loadRuleDetailForEdit = false;
            this.savingForm = false;
            this.resetField();
          }, error => {
            this._notify.error('Error', 'Unable to add the action recommendation rule. Please contact TrackTreads support.');
            console.error(error);
            this.savingForm = false;
          });
        }
        else {
          this._notify.error('Error', 'Unable to add the Component. Please save Rule first.');
        }
      }
    }
  }

  getRuleComponents() {
    this._RuleService.GetActionRecommendationRuleComponents(this._RuleId).subscribe(rec => {
      this.dataSource.data = rec;
      console.log(rec);
      this.loading = false;
    }, err => {
      this._notify.error('Error', 'Unable to load possible recommendations. Please contact TrackTreads support. ');
      console.error(err);
      this.loading = false;
    });
  }

  getDDLDataForInspection() {
    this.loading = true;
    this._RuleService.GetCustomerJobSiteModelForInspection(this.inspectionId).subscribe(rec => {
      this.selectedCustomer = rec.CustomerId;
      this.selectedJobsite = rec.JobSiteId;
      this.selectedModel = rec.ModelId;
      this.loadJobSites();
      this.loadModels();
      this.loadCompartTypes();
      this.getRuleComponents();
    }, err => {
      this._notify.error('Error', 'Unable to load Inspection. Please contact TrackTreads support. ');
      console.error(err);
      this.loading = false;
    });
  }

  editRuleComponent(selectedRow) {
    this._loadRuleDetailForEdit = true;
    this.onChangeCompType();
    this._ruleComponentId = selectedRow.RuleComponentId;
    this.selectedCompartType = selectedRow.ComponentTypeId
    this.selectedCompartSide = selectedRow.Side;
    this.selectedPosition = selectedRow.Position;
    this.selectedActionType = selectedRow.ActionTypeId;
    this.selectedNewPosition = selectedRow.NewPosition;
    this.selectedDesc = selectedRow.Description;
    this.selectedExtendedHrs = selectedRow.LifeExtendedHours;
    this.selectedLabour = selectedRow.LabourCost;
    this.selectedParts = selectedRow.PartCost;
    this.selectedMisc = selectedRow.MiscCost;
    this.selectedTotalCost = selectedRow.LabourCost + selectedRow.PartCost + selectedRow.MiscCost;
  }

  resetField() {
    this._loadRuleDetailForEdit = false;
    this._ruleComponentId = 0;
    this.selectedCompartType = 0;
    this.selectedCompartSide = 0;
    this.selectedPosition = 0;
    this.selectedActionType = 0;
    this.selectedNewPosition = 0;
    this.selectedDesc = '';
    this.selectedExtendedHrs = 0;
    this.selectedLabour = 0;
    this.selectedParts = 0;
    this.selectedMisc = 0;
    this.selectedTotalCost = 0;
  }

  deleteRuleDetail(RuleComponentId: number) {
    this.loading = true;
    this._RuleService.deleteRuleComponentDetail(this.inspectionId, RuleComponentId).subscribe(r => {
      if (r.m_Item1) {
        this._notify.success('Deleted', r.m_Item2);
        this.getRuleComponents();
        this.loading = false;
      } else {
        this._notify.error('Failed', 'Unable to delete Rule component. ');
        console.error(r.m_Item2);
        this.loading = false;
      }
    }, err => {
      console.error(err);
      this._notify.error('Error', 'Failed to delete Rule component. Please contact TrackTreads support. ');
      this.loading = false;
    });
  }

}
